import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectAutocomplete = (state, id) => get(state.autocomplete.data, id, null);

export const selectAutocompleteData = createSelector(
    selectAutocomplete,
    (autocompleteData) => autocompleteData || []
);
